import api from "./apiConfig";

export const REGISTER_MANTENIMIENTO = async (data) => {
	try {
		const response = await api.post("/maintenanceLog", data);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const GET_MANTENIMIENTO = async () => {
	try {
		const response = await api.get("/maintenanceLog");
		return response.data;
	} catch (error) {
		console.error("Error al obtener los usuarios:", error);
		throw error;
	}
};

export const UPDATE_MANTENIMIENTO = async (id, data) => {
	try {
		const response = await api.put(`/maintenanceLog/${id}`, data);
		return response.data;
	} catch (error) {
		console.error("Error al actualizar:", error);
		throw error;
	}
};
